/** 依現有訂閱狀態推開通模式：trial | subscription | null */
export const resolveOpenMode = (data) => {
  const activated = !!(data?.activation_state ?? data?.activate);
  if (!activated) return null;
  if (
    data?.subscription_status === "subscribing" ||
    data?.is_trial === 0 ||
    data?.is_trial === false
  ) {
    return "subscription";
  }
  if (
    data?.subscription_status === "on_trial" ||
    data?.is_trial === 1 ||
    data?.is_trial === true
  ) {
    return "trial";
  }
  return null;
};
